module.exports = __webpack_public_path__ + "img/11_70.4233e26b.png";